import Layout from '@/views/dashbord/Dashbord.vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import { generateRoutes, splitModName } from '../utils/route.module'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { useMessageCenter } from '@/message/useMessageCenter'

const mc = useMessageCenter()

const routes = [
    {
        path: '/redirect/:path*',
        component: () => import('../views/redirect/Index.vue'),
    },
    {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('../views/redirect/Index.vue'),
    },
    {
        path: '/',
        redirect: '/mod/ntp/index',
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/login/Index.vue'),
    },
    // { 去掉注册路由
    //     path: '/nfp-register',
    //     name: 'Register',
    //     component: () => import('../views/login/Register.vue'),
    // },
    {
        path: '/main-page',
        name: 'MainPage',
        component: () => import('../views/mainPage/Index.vue'),
    },
    {
        path: '/mp-user-bind',
        name: 'UserBind',
        component: () => import('../views/mp/UserBind.vue'),
    },
    {
        path: '/demo',
        name: 'Demo',
        component: () => import('../views/Demo.vue'),
    },
    {
        path: '/out',
        name: 'Out',
        component: () => import('../views/Out.vue'),
    },
    {
        path: '/mod/ntp',
        name: 'Main',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import('../views/Main.vue'),
            },
        ],
    },
]

const dynamicRoutes = [
    {
        path: '/mod/ntp',
        name: 'ntp',
        component: Layout,
        children: [
            {
                path: 'notice-list',
                name: 'noticeList',
                component: () => import('../views/notice/noticeMgmt/Index.vue'),
            },
        ],
    },
    {
        path: '/mod/tms',
        name: 'tms',
        component: Layout,
        children: [
            {
                path: 'source-list',
                name: 'sourceList',
                component: () => import('../views/transport/sourceList/CodeScanningBilling.vue'),
            },
            {
                path: 'source-place',
                name: 'sourcePlace',
                component: () => import('../views/transport/sourcePlace/Index.vue'),
            },
            {
                path: 'source-publish',
                name: 'sourcePublish',
                component: () => import('../views/transport/sourcePublish/Index.vue'),
            },
            {
                path: 'waybill-center',
                name: 'waybillCenter',
                component: () => import('../views/transport/waybillCenter/Index.vue'),
            },
            {
                path: 'abnormal-waybill-center',
                name: 'abnormalWaybillCenter',
                component: () => import('../views/transport/abnormalWaybillCenter/Index.vue'),
            },
            {
                path: 'waybill-detail',
                name: 'waybillDetail',
                component: () => import('../views/transport/waybillDetail/Index.vue'),
            },
            {
                path: 'transit-tracking',
                name: 'transitTracking',
                component: () => import('../views/transport/transitTracking/Index.vue'),
            },
            {
                path: 'waybill-basic-stat',
                name: 'waybillBasicStat',
                component: () => import('../views/transport/waybillBasicStatistics/Index.vue'),
            },
            {
                path: 'waybill-template',
                name: 'waybillTemplate',
                component: () => import('../views/transport/waybillTemplate/Index.vue'),
            },
        ],
    },
    {
        path: '/mod/pay',
        name: 'pay',
        component: Layout,
        children: [
            {
                path: 'fund-account-mngt',
                name: 'fundAccountMngt',
                component: () => import('../views/payment/fundAccountMngt/Index.vue'),
            },
            {
                // 资金账户管理
                path: 'fund-account-management',
                name: 'fundAccountManagement',
                component: () => import('../views/payment/fundAccountManagement/Index.vue'),
            },
            {
                path: 'fund-account-detail',
                name: 'fundAccountDetail',
                component: () => import('../views/payment/fundAccountDetail/Index.vue'),
            },
            {
                // 安得资金账户明细
                path: 'annto-fund-account-detail',
                name: 'anntoFundAccountDetail',
                component: () => import('../views/payment/anntoFundAccountDetail/Index.vue'),
            },
            {
                // 客户折扣优惠
                path: 'account-discount',
                name: 'accountDiscount',
                component: () => import('../views/payment/accountDiscount/Index.vue'),
            },
            {
                // 提现明细
                path: 'withdrawals-detail',
                name: 'withdrawalsDetail',
                component: () => import('../views/payment/withdrawalsDetail/Index.vue'),
            },
            {
                path: 'freight-payment',
                name: 'freightPayment',
                component: () => import('../views/payment/freightPayment/Index.vue'),
            },
            {
                path: 'payment-items',
                name: 'paymentItems',
                component: () => import('../views/payment/paymentItems/Index.vue'),
            },
            {
                path: 'revenue-stat',
                name: 'revenueStat',
                component: () => import('../views/payment/revenueStatistics/Index.vue'),
            },
            {
                // 超期未支付明细
                path: 'timeout-unpaid',
                name: 'timeoutUnpaid',
                component: () => import('../views/payment/timeoutUnpaid/Index.vue'),
            },
            // 渠道运费支付
            {
                path: 'channel-freight-payment',
                name: 'channelFreightPayment',
                component: () => import('../views/payment/channelFreightPayment/Index.vue'),
            },
        ],
    },
    // 货源发布
    {
        path: '/mod/publishSource',
        name: 'publishSource',
        component: Layout,
        children: [
            {
                path: 'whole-behicle',
                name: 'wholeVehicle',
                component: () => import('../views/publishSource/wholeVehicle/Index.vue'),
            },

            {
                path: 'whole-behicle-creator',
                name: 'wholeVehicleCreator',
                component: () => import('../views/publishSource/wholeVehicle/Creator.vue'),
            },
        ],
    },

    {
        path: '/mod/invoicing',
        name: 'invoicing',
        component: Layout,
        children: [
            {
                path: 'apply',
                name: 'apply',
                component: () => import('../views/billing/billingApply/Index.vue'),
            },
            {
                path: 'history',
                name: 'history',
                component: () => import('../views/billing/billingHistory/Index.vue'),
            },
            {
                path: 'info-maintain',
                name: 'infoMaintain',
                component: () => import('../views/billing/billingMaintain/Index.vue'),
            },
        ],
    },
    {
        path: '/mod/finance',
        name: 'finance',
        component: Layout,
        children: [
            {
                path: 'customer-state',
                name: 'customerState',
                component: () => import('../views/finance/customerState/Index.vue'),
            },
        ],
    },
    // 基础资料
    {
        path: '/mod/base',
        name: 'base',
        component: Layout,
        children: [
            {
                path: 'driver-manage',
                name: 'driverManage',
                component: () => import('../views/baseInfo/driverManage/Index.vue'),
            },
            {
                path: 'vehicle-manage',
                name: 'vehicleManage',
                component: () => import('../views/baseInfo/vehicleManage/Index.vue'),
            },
            {
                path: 'contacts',
                name: 'contacts',
                component: () => import('../views/baseInfo/contacts/Index.vue'),
            },
            {
                path: 'vehicle-captain-management',
                name: 'vehicleCaptainManagement',
                component: () => import('../views/baseInfo/vehicleCaptainManagement/Index.vue'),
            },

            {
                path: 'familiar-car-manage',
                name: 'familiarCarManage',
                component: () => import('../views/baseInfo/familiarCarManage/Index.vue'),
            },
        ],
    },
    // 报表管理
    {
        path: '/mod/report',
        name: 'report',
        component: Layout,
        children: [
            {
                path: 'revenue-statistics',
                name: 'revenueStatistics',
                component: () => import('../views/reportMgmt/revenueStatistics/Index.vue'),
            },
            {
                path: 'invoicing-statistics',
                name: 'invoicingStatistics',
                component: () => import('../views/reportMgmt/invoicingStatistics/Index.vue'),
            },
            {
                path: 'bank-trans-statistics',
                name: 'bankTransStatistics',
                component: () => import('../views/reportMgmt/bankTransStatistics/Index.vue'),
            },
            {
                path: 'waybill-basic-statistics',
                name: 'waybillBasicStatistics',
                component: () => import('../views/reportMgmt/waybillBasicStatistics/Index.vue'),
            },
        ],
    },
    // 企业管理
    {
        path: '/mod/businessManage',
        name: 'businessManage',
        component: Layout,
        children: [
            {
                path: 'basic-info',
                name: 'basicInfo',
                component: () => import('../views/businessManage/basicInfo/Index.vue'),
            },
            {
                path: 'invoice-info',
                name: 'invoiceInfo',
                component: () => import('../views/businessManage/invoiceInfo/Index.vue'),
            },
            {
                path: 'bank-info',
                name: 'bankInfo',
                component: () => import('../views/businessManage/bankInfo/Index.vue'),
            },
            {
                path: 'account-manage',
                name: 'accountManage',
                component: () => import('../views/businessManage/accountManage/Index.vue'),
            },
            {
                path: 'post-info',
                name: 'postInfo',
                component: () => import('../views/businessManage/roleManage/Index.vue'),
            },
            {
                path: 'organ-manage',
                name: 'organManage',
                component: () => import('../views/businessManage/organizationManage/Index.vue'),
            },
        ],
    },
    // 系统管理
    {
        path: '/mod/systemManage',
        name: 'systemManage',
        component: Layout,
        children: [
            {
                path: 'platform-logger',
                name: 'platformLogger',
                component: () => import('../views/systemManage/platformLogger/Index.vue'),
            },
            // 运单照片采集配置
            {
                path: 'photo-config',
                name: 'waybillPhotoConfig',
                component: () => import('../views/systemManage/waybillPhotoConfig/Index.vue'),
            },
        ],
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

// 记录已注册模块
const registeredRouterRecord = []

/**
 * @description 检查模块是否注册
 * @param {String} modName 模块名
 */
const isModRegistered = modName => {
    return registeredRouterRecord.includes(modName)
}

/**
 * @description 注册模块
 * @param {String} modName 模块名
 */
const regeisterMod = (modName, cb, to) => {
    generateRoutes(modName, dynamicRoutes).then(appendRoutes => {
        // register router
        appendRoutes.forEach(route => {
            router.addRoute(route)
        })
        cb()
    })
    registeredRouterRecord.push(modName)
}
export const wihtePath = ['/login', '/nfp-register', '/main-page', '/mp-user-bind']
router.beforeEach((to, from, next) => {
    mc.post(mc.create('info', '/route/beforeSwitch', '', { from, to }))
    if (wihtePath.includes(to.fullPath)) {
        next()
    } else {
        if (!to.matched) to.matched.push(to.fullPath)
        if (!getToken()) {
            if (from.fullPath !== '/login') ElMessage.error('当前没有登录的用户')
            router.push('/login')
        }
        const modName = splitModName(to.path)
        // 非基础模块 + 模块未注册 = 需要注册模块
        if (modName && !isModRegistered(modName)) {
            setTimeout(() => {
                regeisterMod(modName, next.bind(null, to.fullPath))
                // eslint-disable-next-line no-magic-numbers
            }, 500)
        } else {
            next()
        }
    }
})
export default router
